import { createSlice } from '@reduxjs/toolkit';

import { createRestSlice } from '../../utils/RestSlice';
import MultibonusRepository from '../../repositories/Admin/MultibonusRepository';

const multibonusRestSlice = createRestSlice({
  resource: 'multibonus',
  repository: MultibonusRepository,
  slices: ['createMultibonus'],
});

const initialState = {
  ...multibonusRestSlice.initialState,
};

const multibonusSlice = createSlice({
  name: 'multibonus',
  initialState,
  reducers: {
    ...multibonusRestSlice.reducers,
  },
});
export default multibonusSlice.reducer;

export const multibonusRestHooks = multibonusRestSlice.hooks(multibonusSlice, [
  'admin',
  'MultibonusSlice',
]);
